import { render, staticRenderFns } from "./multiplePhotoShow.vue?vue&type=template&id=0cc155ad&scoped=true"
import script from "./multiplePhotoShow.vue?vue&type=script&lang=js"
export * from "./multiplePhotoShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc155ad",
  null
  
)

export default component.exports